import styled from 'styled-components';

const StyledLabel = styled.span`
  display: inline-block;
  padding: 10px 0 9px;
  vertical-align: middle;
`;

export default StyledLabel;



// WEBPACK FOOTER //
// ./src/elements/Button/styled/StyledLabel.js